module.exports = __webpack_public_path__ + "img/Made_in_France.d7a221c7.png";